import React, { useState, useRef, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Button,
  Popover,
  PopoverBody,
  PopoverHeader,
  Col,
  Row,
  Input,
} from "reactstrap";
import { GetTeacherInformation } from "../../actions/teacherQueries";
import { PostInterestForMail } from "../../actions/teacherMutations";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

export default function RequestAplDemoPopover({ width, minHeight }) {
  const intl = useIntl();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [contactInfo, setContactInfo] = useState(null);

  const phoneRegex = /[^0-9\- ]/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const teacherInfo = GetTeacherInformation();
  const postInterestForMail = useMutation({ mutationFn: PostInterestForMail });

  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${process.env.PUBLIC_URL}/settings.json?rndstr=${uuid()}`)
      .then((res) => {
        setContactInfo(res.data);
      });
  }, []);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const handlePostRequest = () => {
    const email = emailRef.current.value || teacherInfo.data?.email || "";
    const phone = phoneRef.current.value;

    const postData = {
      CustomerPhoneNumber: phone,
      CustomerMail: email,
      Subject: "Apl Demo",
      MailTos: [contactInfo.emailForAplDemo],
    };

    postInterestForMail.mutate(postData, {
      onSuccess: () => {
        toast.success(<FormattedMessage id="ThanksForBookingDemoText" />);
        toggle();
      },
      onError: (err) => {
        toast.warn(formatServiceError(intl, err?.response?.data));
      },
    });
  };

  const validatePhone = (value) => {
    if (value?.length > 0 && phoneRegex.test(value)) {
      setErrors([...errors, "phone"]);
    } else {
      setErrors(errors.filter((er) => er !== "phone"));
    }
  };

  const validateEmail = (value) => {
    if (value?.length < 1 || !emailRegex.test(value)) {
      setErrors([...errors, "email"]);
    } else {
      setErrors(errors.filter((er) => er !== "email"));
    }
  };

  return (
    <>
      <Button
        outline
        title=""
        style={{
          width: width ? width : "initial",
          minHeight: minHeight ? minHeight : "initial",
        }}
        color="primary"
        id="Popover1"
        type="button"
        className="plus-package-btn btn btn-primary"
      >
        <FormattedMessage id="BookDemo" />
      </Button>
      <Popover
        style={{ maxWidth: "450px" }}
        placement="right"
        isOpen={popoverOpen}
        target="Popover1"
        toggle={toggle}
      >
        <PopoverHeader style={{ backgroundColor: "#20a8d8", color: "white" }}>
          <FormattedMessage id="BookDemo" />
        </PopoverHeader>
        <PopoverBody>
          <p className="lead">
            <FormattedMessage id="Hello" /> {teacherInfo.data?.name ?? ""}!
          </p>
          <p>
            <FormattedMessage id="AplDemoGreetingText" />
          </p>
          <Row>
            <Col>
              <label className="me-1 mb-0">
                <FormattedMessage id="Email" /> *
              </label>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>
              <Input
                style={{
                  border: errors.includes("email") ? "1px solid red" : "",
                }}
                innerRef={emailRef}
                type="email"
                defaultValue={teacherInfo.data?.email ?? ""}
                onChange={(data) => validateEmail(data.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <label className="me-1 mb-0">
                <FormattedMessage id="PhoneNumber" />
              </label>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>
              <Input
                style={{
                  border: errors.includes("phone") ? "1px solid red" : "",
                }}
                onChange={(data) => validatePhone(data.target.value)}
                innerRef={phoneRef}
                type="phone"
              />
            </Col>
          </Row>
          <Row className="justify-content-end">
            <Col
              className="pe-0"
              style={{ flexGrow: 0, textWrapMode: "nowrap" }}
            >
              <Button
                color="secondary"
                outline
                onClick={() => setPopoverOpen(false)}
              >
                <FormattedMessage id="Cancel" />
              </Button>
            </Col>
            <Col style={{ flexGrow: 0, textWrapMode: "nowrap" }}>
              <Button
                color="primary"
                outline
                disabled={errors.length > 0}
                onClick={() => handlePostRequest()}
              >
                <FormattedMessage id="SendRequest" />
              </Button>
            </Col>
          </Row>
        </PopoverBody>
      </Popover>
    </>
  );
}
